import parse from 'html-react-parser';

export function parseHtmlWithScriptRemoval(htmlContent: string) {
    return parse(htmlContent, {
        replace: (domNode) =>
            typeof domNode === 'object' &&
                domNode !== null &&
                'name' in domNode &&
                domNode.name === 'script'
                ? false
                : undefined
    })
};